import { isEmpty } from '@jjj/components';
import moment from 'moment';
import { createReducer } from '../../../../../../../helpers/reducer';
import actions from './actions';
import { t } from '../../../../../../../i18n';

const getInitialField = (fieldName, value) => ({
  value,
  error: null,
  name: fieldName,
  touched: false,
});

const initState = {
  loading: false,
  isModalVisible: false,
  editForm: {
    confirmation: getInitialField('confirmation'),
    file: getInitialField('file'),
    future_jobs_date: getInitialField('future_jobs_date', moment().add(1, 'days')),
  },
  errors: [],
};

function validate(attr, value) {
  let error = '';

  if (attr === 'confirmation') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', {
        fieldName: t('dash.units.unit.priceList.add_new_pricelist.add_bulk_markup_modal.markup_label'),
      });
    }
  }

  if (attr === 'future_jobs_date') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', {
        fieldName: t('dash.units.unit.priceList.add_new_pricelist.start_date_label'),
      });
    }
  }

  return error;
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onClearStore() {
  return {
    ...initState,
    editForm: {
      markup: getInitialField('confirmation'),
    },
  };
}

function onShowModal(state) {
  return {
    ...state,
    isModalVisible: true,
  };
}

function onCloseModal(state) {
  return {
    ...state,
    isModalVisible: false,
  };
}

function onCreatePriceListRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onCreatePriceListSuccess(state) {
  return {
    ...state,
    loading: false,
  };
}

function onCreatePriceListError(state, { payload }) {
  const { errors } = payload;

  const createPriceListErrors = Object.entries(errors).reduce((acc, [key, value]) => {
    const errorKeyTranslated = t(`dash.units.unit.priceList.add_new_pricelist.errors.${key}`);

    if (Array.isArray(value)) {
      acc.push(`${errorKeyTranslated}: ${value.join(', ')}`);
    } else if (typeof value === 'object') {
      const nestedErrors = Object.entries(value).reduce((nestedAcc, [_subKey, subValue]) => {
        Object.entries(subValue).forEach(([field, messages]) => {
          nestedAcc.push(`${field} ${messages.join(', ')}`);
        });

        return nestedAcc;
      }, []);
      acc.push(`${errorKeyTranslated}: ${nestedErrors.join(', ')}`);
    }

    return acc;
  }, []);

  return {
    ...state,
    errors: createPriceListErrors,
    loading: false,
  };
}

export default createReducer(initState, {
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.SHOW_MODAL]: onShowModal,
  [actions.CLOSE_MODAL]: onCloseModal,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.IMPORT_CSV_REQUEST]: onCreatePriceListRequest,
  [actions.IMPORT_CSV_SUCCESS]: onCreatePriceListSuccess,
  [actions.IMPORT_CSV_ERROR]: onCreatePriceListError,
});
